import { render, staticRenderFns } from "./UiDropDown.vue?vue&type=template&id=536b0453&scoped=true"
import script from "./UiDropDown.vue?vue&type=script&lang=js"
export * from "./UiDropDown.vue?vue&type=script&lang=js"
import style0 from "./UiDropDown.vue?vue&type=style&index=0&id=536b0453&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536b0453",
  null
  
)

export default component.exports